import { Amplify } from 'aws-amplify';
import { Authenticator, View, Image, useTheme, Text, components } from '@aws-amplify/ui-react';
import awsExports from './aws-exports';
import Button from '@mui/material/Button';
import './App.css';
import '@aws-amplify/ui-react/styles.css';
import MainSite from './components/MainSite';
import QrScan from './components/QrScan';
import HomePage from './components/HomePage';
import Inventory from './components/Inventory';
import Footer from './components/Footer';
import CheckIn from './components/CheckIn';
import CheckOut from './components/CheckOut';
import CheckedOut from './components/CheckedOut';
import DamagedEq from './components/DamagedEq';
import Dashboard from './components/Dashboard';
import { Route, Routes } from 'react-router-dom';


Amplify.configure(awsExports);

function App() {

  const components = {
    Header() {
      const { tokens } = useTheme();

      return (
        <View textAlign="center" padding={tokens.space.large}>
          <Image id="logo"
            alt="ShiVish Entertainment logo"
            src="/img/shivish_logo.png"
            width={250} height={75}
          />
        </View>
      );
    },
  Footer() {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large} fontSize="10px">
        <Text color={tokens.colors.neutral[80]}>
          &copy; All Rights Reserved - George Mason University - IT493 Tech Titans
        </Text>
      </View>
    );
  }
};
  return (
    <Authenticator hideSignUp={true} components={components}>
      {({ signOut, user }) => (
        <main>

          <MainSite />
          <Routes>
            <Route path='/QrScan' element={<QrScan />} />
            <Route path='/Inventory' element={<Inventory />} />
            <Route path='/DamagedEq' element={<DamagedEq />} />
            <Route path='/' element={<HomePage />} />
            <Route path='/CheckIn' element={<CheckIn />} />
            <Route path='/CheckOut' element={<CheckOut />} />
            <Route path='/CheckedOut' element={<CheckedOut />} />
            <Route path='/Dashboard' element={<Dashboard />} />
          </Routes>

          <Footer />

        </main>
      )}
    </Authenticator>
  );
}

export default App;
